<template>
  <div class="page-404">
    Запрашиваемый ресурс не найден<br />
    <router-link :to="{ name: 'home' }">
      Вернуться на главную
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Page404"
};
</script>

<style lang="scss">
.page-404 {
  font-size: 24px;
  font-weight: fw(bold);
  text-align: center;
  color: colors(text-2);
  text-shadow: 0 0 5px #fff;
}
</style>
